import { useStaticQuery, graphql } from 'gatsby';
import { useIntl } from 'react-intl';

interface ProductDetailPage {
  node: {
    contentful_id: string;
    node_locale: string;
  }
}

const useProductDetailPageExists = (contentfulId: string | undefined) => {
  const { locale } = useIntl();
  const { productDetailPages } = useStaticQuery(graphql`
    query {
      productDetailPages: allContentfulProductContent{
        edges {
          node {
            contentful_id
            node_locale
          }
        }
      }
    }
  `);

  if (!contentfulId) {
    return false;
  }

  const productDetailPage = productDetailPages.edges.find((productDetailPageData: ProductDetailPage) => (
    productDetailPageData.node.contentful_id === contentfulId
    && productDetailPageData.node.node_locale === locale));

  return Boolean(productDetailPage);
};

export default useProductDetailPageExists;
